export const DEFAULT_LOCALE = 'ru';
export function isValidLocale(locale) {
    return ['en', 'ru', 'tk'].includes(locale);
}
//# sourceMappingURL=locale.types.js.map